{
  "sessionsCount_one": "{{count}} session",
  "sessionsCount_zero": "{{count}} sessions",
  "sessionsCount_other": "{{count}} sessions",
  "viewersCount_one": "{{count}} student",
  "viewersCount_zero": "{{count}} students",
  "viewersCount_other": "{{count}} students",
  "title": "Videos",
  "subtitle": "Upload, organize and track your lesson videos. They are delivered through protected streaming, only inside the member area.",
  "loading": "Loading videos...",
  "loadError": "Could not load the videos.",
  "empty": "No videos uploaded yet.",
  "notFound": "Video not found.",
  "back": "Back to videos",
  "openStudio": "Open in studio",
  "failedReason": "Processing failed: {{reason}}",
  "pagination": {
    "label": "Pagination",
    "previous": "Previous",
    "next": "Next",
    "status": "Page {{page}} of {{total}}"
  },
  "status": {
    "UPLOADING": "Waiting for upload",
    "PROCESSING": "Processing",
    "READY": "Ready",
    "FAILED": "Failed"
  },
  "visibility": {
    "PRIVATE": "Private",
    "SHAREABLE": "Shareable",
    "PUBLIC": "Public"
  },
  "visibilityHint": {
    "PRIVATE": "Only students with access to the lesson can watch, inside the member area.",
    "SHAREABLE": "Reserved for share links (coming soon). For now it behaves like Private.",
    "PUBLIC": "Anyone can watch without signing in, but only on your member area domains."
  },
  "upload": {
    "cta": "Click or drag a video to upload",
    "hint": "Protected streaming up to 4K · max 20 GB",
    "sending": "Uploading video...",
    "done": "Video uploaded. Processing starts in a moment.",
    "error": "Could not upload the video.",
    "unsupported": "Unsupported file. Upload a video file.",
    "tooLarge": "Video too large ({{size}}). Max: 20 GB."
  },
  "delete": {
    "button": "Delete video",
    "title": "Delete video?",
    "description": "Lessons using this video will stop playing it. This cannot be undone.",
    "confirm": "Delete"
  },
  "toasts": {
    "deleted": "Video deleted",
    "error": "Could not complete the action.",
    "saved": "Changes saved",
    "thumbnailUpdated": "Thumbnail updated",
    "subtitleSaved": "Subtitle saved",
    "subtitleRemoved": "Subtitle removed"
  },
  "details": {
    "title": "Details",
    "name": "Title",
    "description": "Description",
    "visibility": "Visibility",
    "save": "Save",
    "watermarkText": "Watermark text",
    "watermarkHint": "Shown over the video in the player. Changes apply on the next playback, no reprocessing needed.",
    "watermarkCustom": "Custom text",
    "watermarkPosition": "Watermark position"
  },
  "thumbnails": {
    "title": "Thumbnail",
    "description": "Pick a suggestion, capture the paused frame from the player or upload an image.",
    "candidate": "Use suggestion {{index}}",
    "custom": "Current thumbnail",
    "useFrame": "Use frame at {{time}}",
    "upload": "Upload image",
    "frameHint": "Play and pause at the moment you want to capture."
  },
  "subtitles": {
    "title": "Subtitles",
    "description": "Upload SRT or WebVTT files. One subtitle per language.",
    "empty": "No subtitles yet.",
    "remove": "Remove subtitle {{label}}",
    "removeConfirm": "Remove the \"{{label}}\" subtitle?",
    "lang": "Language",
    "label": "Display name",
    "chooseFile": "Choose file",
    "noFile": "No file selected",
    "add": "Save subtitle",
    "invalidFile": "Invalid subtitle file.",
    "replaceWarning": "A {{language}} subtitle already exists. It will be replaced when you save.",
    "replace": "Replace subtitle"
  },
  "analytics": {
    "title": "Audience",
    "viewers": "Students",
    "sessionsHint_one": "{{count}} session",
    "sessionsHint_zero": "{{count}} sessions",
    "sessionsHint_other": "{{count}} sessions",
    "watchedHours": "Watch time",
    "avgCoverage": "Average watched",
    "completed": "Completed",
    "completedHint": "Watched 90% or more",
    "byViewer": "By student",
    "bySession": "Sessions",
    "viewer": "Student",
    "sessions": "Sessions",
    "coverage": "Watched",
    "watched": "Time",
    "lastSeen": "Last seen",
    "startedAt": "Started",
    "device": "Browser and device",
    "location": "Location",
    "endReason": "Ended",
    "empty": "No views yet.",
    "valuesTitle": "Costs and usage in the period"
  },
  "endReason": {
    "ACTIVE": "Watching",
    "ENDED": "Left the lesson",
    "EXPIRED": "Inactive",
    "REPLACED": "Opened elsewhere"
  },
  "reupload": {
    "title": "Upload the file again",
    "description": "Upload the file again for this same video. Lessons that already use it stay linked."
  },
  "usage": {
    "title": "Video usage",
    "month": "Month",
    "storage": "Storage",
    "storageHint_one": "{{count}} video",
    "storageHint_zero": "{{count}} videos",
    "storageHint_other": "{{count}} videos",
    "processed": "Processed in the period",
    "processedHint": "Output: SD {{sd}} · HD {{hd}} · 4K {{uhd}} min",
    "watched": "Watched in the period",
    "watchedHint": "$t(adminVideos:sessionsCount, {\"count\": {{sessions}} }) · $t(adminVideos:viewersCount, {\"count\": {{viewers}} }) · {{data}} downloaded",
    "gb": "{{value}} GB",
    "minutes": "{{value}} min",
    "cost": "Estimated cost",
    "costHint": "Storage {{storage}} · Processing {{processing}} · Delivery {{delivery}}"
  },
  "tenantUsage": {
    "title": "Video usage by school",
    "subtitle": "Video volume per school in the period and the actual Google Cloud cost.",
    "loadError": "Could not load the usage.",
    "empty": "No schools found.",
    "name": "School",
    "videos": "Videos",
    "storage": "Storage (GB)",
    "processed": "Processed (min)",
    "watched": "Watched (min)",
    "costStorage": "Storage",
    "costProcessing": "Processing",
    "costDelivery": "Delivery",
    "costTotal": "Total",
    "grandTotal": "Grand total",
    "platform": "Platform (unallocated)"
  },
  "failure": {
    "FILE_TOO_LARGE": "the file exceeds the 20 GB limit.",
    "NO_VIDEO_STREAM": "the file has no valid video track.",
    "VIDEO_TOO_SHORT": "the video must be at least 5 seconds long.",
    "PROBE_FAILED": "the file could not be read. It may be corrupted or in an unsupported format."
  },
  "watermarkText": {
    "NONE": "None",
    "USER_EMAIL": "User email",
    "TENANT_NAME": "School name",
    "VIDEO_ID": "Video code",
    "CUSTOM": "Custom"
  },
  "watermarkPosition": {
    "TOP_RIGHT": "Top right",
    "BOTTOM_RIGHT": "Bottom right",
    "BOTTOM_LEFT": "Bottom left",
    "TOP_LEFT": "Top left",
    "FLOATING": "Floating"
  },
  "library": {
    "tabs": {
      "videos": "Videos",
      "viewers": "Students and costs"
    },
    "searchPlaceholder": "Search by title",
    "statusFilter": "Filter by status",
    "allStatuses": "All statuses",
    "noResults": "No videos match this search.",
    "columns": {
      "video": "Video",
      "visibility": "Visibility",
      "date": "Date",
      "views": "Views",
      "watchTime": "Watch time",
      "subtitles": "Subtitles",
      "data": "Data downloaded",
      "storage": "Storage",
      "cost": "Cost"
    },
    "selectAll": "Select all videos on this page",
    "selectOne": "Select {{title}}",
    "selected_one": "{{count}} selected",
    "selected_zero": "{{count}} selected",
    "selected_other": "{{count}} selected",
    "clearSelection": "Clear selection",
    "bulkVisibility": "Change visibility",
    "bulkDelete": "Delete",
    "bulkDeleteTitle": "Delete selected videos?",
    "bulkDeleteDescription_one": "The selected video will be deleted. Lessons that use it will stop playing.",
    "bulkDeleteDescription_zero": "The {{count}} selected videos will be deleted. Lessons that use them will stop playing.",
    "bulkDeleteDescription_other": "The {{count}} selected videos will be deleted. Lessons that use them will stop playing.",
    "bulkUpdated": "Visibility updated.",
    "bulkDeleted": "Videos deleted.",
    "bulkPartial": "{{failed}} of {{total}} videos could not be changed.",
    "openStudio": "Open {{title}} in the studio",
    "delete": "Delete {{title}}",
    "subtitleCount_one": "{{count}} language",
    "subtitleCount_zero": "{{count}} languages",
    "subtitleCount_other": "{{count}} languages",
    "noSubtitles": "No subtitles",
    "details": {
      "expand": "Show metrics for {{title}}",
      "collapse": "Hide metrics for {{title}}",
      "cost": "Cost in the period",
      "watchedHint": "$t(adminVideos:sessionsCount, {\"count\": {{sessions}} }) · $t(adminVideos:viewersCount, {\"count\": {{viewers}} }) · {{data}} downloaded",
      "costBreakdown": "Delivery {{delivery}} · Storage {{storage}} · Processing {{processing}}"
    }
  },
  "viewersPage": {
    "title": "Students and costs",
    "subtitle": "See what each student watched, how much of each video they have seen, and what it cost and will be billed in the period.",
    "month": "Month",
    "search": "Search students by name or email",
    "loading": "Loading students...",
    "loadError": "Could not load usage per student.",
    "empty": "No student watched videos in this period.",
    "noMatch": "No student matches this search.",
    "totals": {
      "viewers": "Students",
      "watched": "Watch time",
      "cost": "Total cost",
      "charge": "To bill",
      "chargeHint": "Markup applied: {{percent}}%"
    },
    "columns": {
      "student": "Student",
      "videos": "Videos",
      "watched": "Watch time",
      "cost": "Delivery cost",
      "charge": "To bill",
      "lastSeen": "Last seen",
      "progress": "Progress",
      "sessions": "Sessions",
      "data": "Data downloaded"
    },
    "anonymous": "Public access (not signed in)",
    "removedVideo": "Removed video",
    "expand": "Show videos for {{name}}",
    "collapse": "Hide videos for {{name}}",
    "exportCsv": "Export CSV",
    "csv": {
      "student": "Student",
      "email": "Email",
      "video": "Video",
      "watchedSeconds": "Seconds watched",
      "progress": "Progress (%)",
      "cost": "Delivery cost (USD)",
      "charge": "To bill (USD)",
      "data": "Data downloaded (GB)"
    },
    "note": "Per student we show delivery only. The cost is the actual Google Cloud cost, split by what each student downloaded; where \"—\" appears, Google Cloud has not reported the cost for that period yet. Storage and processing are costs of the course and are included in the total cost. The amount includes no profit.",
    "estimated": "Partly estimated: the student's browser did not report usage."
  },
  "dateRange": {
    "from": "From",
    "to": "To",
    "placeholder": "DD/MM/YYYY",
    "order": "The start date cannot be after the end date.",
    "presets": {
      "thisMonth": "This month",
      "lastMonth": "Last month",
      "last30": "Last 30 days"
    }
  },
  "picker": {
    "tabs": {
      "upload": "Upload new",
      "existing": "Use existing"
    },
    "search": "Search videos by title",
    "empty": "You have no ready videos yet. Upload a new one.",
    "select": "Use the video {{title}}",
    "views_one": "{{count}} view",
    "views_zero": "{{count}} views",
    "views_other": "{{count}} views",
    "usedIn_one": "Used in {{count}} lesson",
    "usedIn_zero": "Used in {{count}} lessons",
    "usedIn_other": "Used in {{count}} lessons",
    "unused": "Not used in lessons yet"
  },
  "costs": {
    "title": "Costs",
    "provisional": "Provisional",
    "refresh": "Refresh now",
    "synced": "Costs updated.",
    "asOf": "Actual Google Cloud data up to {{date}}",
    "categories": {
      "delivery": "Delivery (CDN)",
      "storage": "Storage",
      "processing": "Processing"
    },
    "real": "Actual",
    "pending": "Waiting for actual Google Cloud data.",
    "partial": "Part of the period has no actual Google Cloud data yet."
  },
  "studioTabs": {
    "settings": "Settings",
    "analytics": "Analytics"
  }
}
